module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-479.f4e44fb.woff2";